module.exports = __webpack_public_path__ + "static/media/BM 04.ab634907.png";